import tippy from 'tippy.js';

document.addEventListener('turbo:load', () => {
  tippy('[data-tippy-content]');
});
